import { createFileRoute } from "@tanstack/react-router";
import { BeancountIosComponent } from "@/pages/beancount-ios";
import { head, loader } from "@/pages/beancount-ios.meta";

export const Route = createFileRoute("/($locale)/beancount-ios")({
  loader,
  head,
  component: BeancountIosComponent,
});
